import React, { Component } from 'react';
import { Table, Row, Button, message, Spin, DatePicker, Alert, Input, Tooltip } from 'antd';
import moment from 'moment';
import { dataDefault } from './data';
import imgSave from "../../../components/table/saveImg";
import Auth from "../../../components/table/Auth";
import TableText from "@/components/table/TableText";
import IsLableAuth from "@/components/table/IsLableAuth";
import Productivity from "./Productivity";
import { compute } from "./Productivity";
import { calculation } from '../../../method';
import correspond, { getChart } from './compute';
import FileSaver from "file-saver";
import Chart from './components/Chart'

const { MonthPicker } = DatePicker;
const { TextArea } = Input;

function numConvert(num = 0) {
    num = Number(num || "0")
    return num
};

const getJson = (arr, obj, value = 0) => {
    return arr.reduce((a, b) => a && a[b] ? a[b] : value, obj)
}

const totalIndexFooter = [0, 17, 18, 59, 65];
class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false,
            update: false,
            note: {
                note: ""
            },
            data7_1: [],
            dataIndex: []
        }
    }

    componentDidMount() {
        this.getDateData(this.state.date);
    }

    computeNum = async (data) => {
        const listName = ['now_year', 'last_year'];
        listName.forEach(name => {
            data[3][name] = (numConvert(data[1][name]) == 0 ? 0 : numConvert(data[2][name]) / numConvert(data[1][name])).toFixed(4);
            data[4][name] = (numConvert(data[2][name]) == 0 ? 0 : numConvert(data[6][name]) / numConvert(data[2][name])).toFixed(2);
            data[5][name] = (numConvert(data[6][name]) + numConvert(data[7][name]) + numConvert(data[8][name])).toFixed(2);
            data[17][name] = ([10, 11, 15, 16].reduce((a, b) => { a += numConvert(data[b][name]); return a }, 0)).toFixed(2);
            data[22][name] = (numConvert(data[19][name]) == 0 ? 0 : numConvert(data[21][name]) / numConvert(data[19][name])).toFixed(2);
            data[23][name] = (numConvert(data[1][name]) == 0 || numConvert(data[20][name]) == 0 ? 0 : (numConvert(data[21][name]) / numConvert(data[19][name])) / (numConvert(data[1][name]) / numConvert(data[20][name]))).toFixed(2);
            data[24][name] = (numConvert(data[5][name]) == 0 ? 0 : numConvert(data[17][name]) / numConvert(data[5][name])).toFixed(4);
            data[25][name] = (numConvert(data[21][name]) == 0 ? 0 : numConvert(data[17][name]) / numConvert(data[21][name])).toFixed(2);
            data[26][name] = (numConvert(data[21][name]) == 0 ? 0 : numConvert(data[10][name]) / numConvert(data[21][name])).toFixed(2);
            data[30][name] = (numConvert(data[5][name]) == 0 ? 0 : numConvert(data[6][name]) / numConvert(data[5][name])).toFixed(4);
            data[31][name] = (numConvert(data[17][name]) == 0 ? 0 : numConvert(data[28][name]) / numConvert(data[17][name])).toFixed(4);
            data[32][name] = (numConvert(data[27][name]) == 0 ? 0 : numConvert(data[28][name]) / numConvert(data[27][name])).toFixed(2);
            data[33][name] = (numConvert(data[27][name]) == 0 ? 0 : numConvert(data[29][name]) / numConvert(data[27][name])).toFixed(2);
            data[34][name] = (numConvert(data[27][name]) == 0 ? 0 : numConvert(data[6][name]) / numConvert(data[27][name])).toFixed(2);
            data[38][name] = (numConvert(data[5][name]) == 0 ? 0 : numConvert(data[7][name]) / numConvert(data[5][name])).toFixed(4);
            data[39][name] = (numConvert(data[17][name]) == 0 ? 0 : numConvert(data[36][name]) / numConvert(data[17][name])).toFixed(4);
            data[40][name] = (numConvert(data[35][name]) == 0 ? 0 : numConvert(data[36][name]) / numConvert(data[35][name])).toFixed(2);
            data[41][name] = (numConvert(data[35][name]) == 0 ? 0 : numConvert(data[37][name]) / numConvert(data[35][name])).toFixed(2);
            data[42][name] = (numConvert(data[35][name]) == 0 ? 0 : numConvert(data[7][name]) / numConvert(data[35][name])).toFixed(2);
            data[46][name] = (numConvert(data[5][name]) == 0 ? 0 : numConvert(data[8][name]) / numConvert(data[5][name])).toFixed(4);
            data[47][name] = (numConvert(data[17][name]) == 0 ? 0 : numConvert(data[44][name]) / numConvert(data[17][name])).toFixed(4);
            data[48][name] = (numConvert(data[43][name]) == 0 ? 0 : numConvert(data[44][name]) / numConvert(data[43][name])).toFixed(2);
            data[49][name] = (numConvert(data[43][name]) == 0 ? 0 : numConvert(data[45][name]) / numConvert(data[43][name])).toFixed(2);
            data[50][name] = (numConvert(data[43][name]) == 0 ? 0 : numConvert(data[8][name]) / numConvert(data[43][name])).toFixed(2);
            data[54][name] = (numConvert(data[17][name]) == 0 ? 0 : numConvert(data[52][name]) / numConvert(data[17][name])).toFixed(4);
            data[55][name] = (numConvert(data[51][name]) == 0 ? 0 : numConvert(data[52][name]) / numConvert(data[51][name])).toFixed(2);
            data[56][name] = (numConvert(data[51][name]) == 0 ? 0 : numConvert(data[53][name]) / numConvert(data[51][name])).toFixed(2);
            data[57][name] = (numConvert(data[21][name]) - numConvert(data[27][name]) - numConvert(data[35][name]) - numConvert(data[43][name]) - numConvert(data[51][name])).toFixed(2);
            data[58][name] = (numConvert(data[17][name]) - numConvert(data[28][name]) - numConvert(data[36][name]) - numConvert(data[44][name]) - numConvert(data[52][name])).toFixed(2);
            data[61][name] = (numConvert(data[21][name]) == 0 ? 0 : numConvert(data[60][name]) / numConvert(data[21][name])).toFixed(4);
            data[64][name] = (numConvert(data[60][name]) == 0 ? 0 : (numConvert(data[62][name]) + numConvert(data[63][name])) / numConvert(data[60][name])).toFixed(2);
            // data[68][name] = (numConvert(data[66][name]) == 0 ? 0 : numConvert(data[67][name]) / numConvert(data[66][name])).toFixed(2);
            // data[69][name] = (numConvert(data[17][name]) == 0 ? 0 : numConvert(data[67][name]) / numConvert(data[17][name])).toFixed(4);
        });
        data.forEach((item, i) => {
            data[i].variance = (numConvert(data[i].last_year) == 0 ? 0 : (numConvert(data[i].now_year) - numConvert(data[i].last_year)) / numConvert(data[i].last_year)).toFixed(4);
        });
        data[16].variance = calculation(data[16].now_year, data[17].now_year, 4);
        console.log(data);
        this.setState({ data }, () => {
            this.onSave();
        });
    }
    onChange = (name, value, i) => {
        // 简单粗暴的深拷贝
        let data = JSON.parse(JSON.stringify(this.state.data));
        data[i][name] = value;
        this.computeNum(data);
    }

    onChangeProperty = (name, value) => {
        let property = this.state.property;
        property[name] = value;
        this.setState({ property });
    }

    getDateData = async (date) => {
        const dataBegin = JSON.stringify(dataDefault);
        let data = JSON.parse(dataBegin);

        fetch(`/_hr_9_info?year=${moment(date).format('YYYY')}&month=${moment(date).format('MM')}`, { credentials: 'include' }).then(x => x.json()).then(x => {

            if (x.data.table && x.data.table.length > 0) {
                data = x.data.table.sort((a, b) => {
                    return numConvert(a.sort) - numConvert(b.sort)
                });
            }

            // 从1.1获取数据
            data[1].now_year = getJson([0, 'year_actual'], x.data.data1_1 || []);
            data[2].now_year = getJson([1, 'year_actual'], x.data.data1_1 || []);
            data[6].now_year = getJson([5, 'year_actual'], x.data.data1_1 || []);
            data[7].now_year = getJson([6, 'year_actual'], x.data.data1_1 || []);
            data[8].now_year = getJson([7, 'year_actual'], x.data.data1_1 || []);
            data[9].now_year = getJson([21, 'year_actual'], x.data.data1_1 || []);
            data[10].now_year = getJson([11, 'year_thisy_payroll_cost'], x.data.data7_1 || []); //纯工资
            data[11].now_year = getJson([13, 'year_thisy_payroll_cost'], x.data.data7_1 || []);//年终奖
            data[15].now_year = getJson([12, 'year_thisy_payroll_cost'], x.data.data7_1 || []);//五险一金
            data[16].now_year = getJson([14, 'year_thisy_payroll_cost'], x.data.data7_1 || []);//五险一金
            data[66].now_year = getJson([17, 'year_thisy_payroll_cost'], x.data.data7_1 || []);//五险一金
            data[67].now_year = getJson([18, 'year_thisy_payroll_cost'], x.data.data7_1 || []);//五险一金
            data[68].now_year = getJson([19, 'year_thisy_payroll_cost'], x.data.data7_1 || []);//五险一金
            data[69].now_year = calculation(
                getJson([19, 'year_thisy_payroll_cost'], x.data.data7_1 || []),
                Number(getJson([16, 'year_thisy_payroll_cost'], x.data.data7_1 || []))
                +
                Number(getJson([19, 'year_thisy_payroll_cost'], x.data.data7_1 || []))
            );

            data[1].last_year = getJson([0, 'year_actual'], x.data.dataLast1_1 || []);
            data[2].last_year = getJson([1, 'year_actual'], x.data.dataLast1_1 || []);
            data[6].last_year = getJson([5, 'year_actual'], x.data.dataLast1_1 || []);
            data[7].last_year = getJson([6, 'year_actual'], x.data.dataLast1_1 || []);
            data[8].last_year = getJson([7, 'year_actual'], x.data.dataLast1_1 || []);
            data[9].last_year = getJson([21, 'year_actual'], x.data.dataLast1_1 || []);
            data[10].last_year = getJson([11, 'year_lasty_payroll_cost'], x.data.data7_1 || []); //纯工资
            data[11].last_year = getJson([13, 'year_lasty_payroll_cost'], x.data.data7_1 || []);//年终奖
            data[15].last_year = getJson([12, 'year_lasty_payroll_cost'], x.data.data7_1 || []);//五险一金
            data[16].last_year = getJson([14, 'year_lasty_payroll_cost'], x.data.data7_1 || []);//其他费用
            data[66].last_year = getJson([17, 'year_lasty_payroll_cost'], x.data.data7_1 || []);//五险一金
            data[67].last_year = getJson([18, 'year_lasty_payroll_cost'], x.data.data7_1 || []);//五险一金
            data[68].last_year = getJson([19, 'year_lasty_payroll_cost'], x.data.data7_1 || []);//五险一金
            data[69].last_year = calculation(
                getJson([19, 'year_lasty_payroll_cost'], x.data.data7_1 || []),
                Number(getJson([16, 'year_lasty_payroll_cost'], x.data.data7_1 || []))
                +
                Number(getJson([19, 'year_lasty_payroll_cost'], x.data.data7_1 || []))
            );

            data = correspond({ date, data, data7_7: x.data.data7_7 || [] });

            if (!data[0].id) {
                this.setState({
                    loading: false,
                    data,
                    note: x.data.note || { note: "" }
                }, () => {
                    this.onSave();
                });
                return
            }

            this.setState({
                loading: false,
                note: x.data.note || { note: "" },
                data7_1: x.data.data7_1 || [],
                dataIndex: x.data.dataIndex || []
            }, () => {
                this.computeNum(data);
            });

        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        const { date, note, data7_1, dataIndex } = this.state;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("MM");
        let data = this.state.data.map(x => ({ ...x, year, month }));

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        dataFrom.append('dataIndex', JSON.stringify(compute(data, data7_1, dataIndex).map(x => ({ ...x, year, month }))));
        dataFrom.append('note', JSON.stringify({ ...note, year, month }));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/hrAdd_9', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            getChart(year);
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id || !dataIndex[0] || !dataIndex[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {
        // 由HR9.0迁移至ES7.7
        this.setState({ print: true, loading: true }, () => {
            imgSave('table3_3_2', 1.5, '7.8', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }
    downloadExcel = () => {
        const hotel = sessionStorage.getItem('hotelName') || "";
        const tableName = `${hotel} ${moment(this.state.date).format('YYYY')} 7.8 Labor Cost Productivity Analysis 人力成本生产率分析表`
        const innerHtml = `
          <caption>${tableName}</caption>
          ${document.getElementById('table7_8').innerHTML.replace(/<table class="">/g, '<table border="1">')}
        `;

        var html = "<html><head><meta charset='utf-8' /></head><body>" + innerHtml + "</body></html>";
        var blob = new Blob([html], { type: "application/vnd.ms-excel" });
        FileSaver.saveAs(blob, `${(tableName) + (this.state.date)}.xls`);
        this.setState({ print: false });
    }
    render() {
        const { data, note, date, loading, data7_1, dataIndex, print } = this.state;
        const year = Number(moment(date).format('YYYY'));
        const percentIndex = [3, 24, 30, 31, 38, 39, 46, 47, 54, 61, 69];
        // const inputIndex = [12, 13, 14, 19, 20, 21, 27, 28, 29, 35, 36, 37, 43, 44, 45, 52, 53, 51, 60, 62, 63];
        const inputIndex = [];
        const noIndex = [0, 18, 59, 65];
        const deleteRow = [12, 13, 14];
        const columns = [{
            title: ``,
            dataIndex: 'name',
            key: 'name',
            align: "center",
            width: 500,
            render: (text, record, index) => {
                const props = { text, index, type: 'text', name: "name", onChange: this.onChange, totalIndex: totalIndexFooter };
                if (deleteRow.includes(index)) {
                    return {
                        porps: {
                            colSpan: 0
                        }
                    }
                }
                if (noIndex.includes(index)) {
                    return {
                        children: <TableText data={props} />,
                        props: {
                            colSpan: 4
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: `今年YTD年累计`,
            dataIndex: 'now_year',
            key: 'now_year',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = [`今年YTD年累计`];
                const props = {
                    text, index, type: inputIndex.includes(index) && !print ? 'inputNumber' : percentIndex.includes(index) ? 'percent' : 'number', name: "now_year", onChange: this.onChange, totalIndex: totalIndexFooter,
                    compared: {
                        title,
                        record,
                        sqlName: "hr_9"
                    }
                };
                if (deleteRow.includes(index)) {
                    return {
                        porps: {
                            colSpan: 0
                        }
                    }
                }
                if (noIndex.includes(index)) {
                    return {
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: `去年YTD年累计`,
            dataIndex: 'last_year',
            key: 'last_year',
            align: "center",
            width: 150,
            render: (text, record, index) => {
                const title = [`去年YTD年累计`];
                const props = {
                    text, index, type: inputIndex.includes(index) && !print ? 'inputNumber' : percentIndex.includes(index) ? 'percent' : 'number', name: "last_year", onChange: this.onChange, totalIndex: totalIndexFooter,
                    compared: {
                        title,
                        record,
                        sqlName: "hr_9"
                    }
                };
                if (deleteRow.includes(index)) {
                    return {
                        porps: {
                            colSpan: 0
                        }
                    }
                }
                if (noIndex.includes(index)) {
                    return {
                        props: {
                            colSpan: 0
                        }
                    }
                }
                return (
                    <TableText data={props} />
                )
            }
        }, {
            title: `Variance`,
            dataIndex: 'variance',
            key: 'variance',
            align: "center",
            width: 300,
            render: (text, record, index) => {
                const title = [`Variance`];
                const props = {
                    text, index, type: 'percent', name: "variance", onChange: this.onChange, totalIndex: totalIndexFooter,
                    compared: {
                        title,
                        record,
                        sqlName: "hr_9"
                    }
                };
                if (deleteRow.includes(index)) {
                    return {
                        porps: {
                            colSpan: 0
                        }
                    }
                }
                if (noIndex.includes(index)) {
                    return {
                        props: {
                            colSpan: 0
                        }
                    }
                }

                if (index == 16) {
                    const num = numConvert(data[17].now_year) == 0 ? 0 : numConvert(data[16].now_year) / numConvert(data[17].now_year);
                    if (num < 0.03) {
                        return (
                            <TableText data={{ ...props, text: "", type: "" }} />
                        )
                    }
                    return (
                        <TableText data={{ ...props, text: "此金额不应超过人力成本总金额的3%", type: "text", warn: true }} />
                    )
                }
                if (index == 57) {
                    if (numConvert(data[57].now_year).toFixed(2) == 0) {
                        return (
                            <TableText data={{ ...props, text: 0, type: "number" }} />
                        )
                    }
                    return (
                        <TableText data={{ ...props, text: "Please explain the details. 请解释原因.", type: "text", warn: true }} />
                    )
                }
                if (index == 58) {
                    if (numConvert(data[58].now_year).toFixed(2) == 0) {
                        return (
                            <TableText data={{ ...props, text: 0, type: "number" }} />
                        )
                    }
                    return (
                        <TableText data={{ ...props, text: "Please explain the details. 请解释原因.", type: "text" }} />
                    )
                }

                return (
                    <TableText data={props} />

                )
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table">
                    <Row className="title" id="table3_3_2"  >
                        <Row>
                            7.8 Labor Cost Productivity Analysis 人力成本生产率分析表
                        </Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str);
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            id="table7_8"
                            pagination={false}
                            className="content"
                            scroll={this.state.print ? {} : { y: 550 }}
                            rowKey={(record, index) => index}
                        />
                        <Productivity data={data} data7_1={data7_1} dataSource={dataIndex} date={date} />
                        <Row style={{
                            margin: "30px 0 10px 0"
                        }}>7.8.1 Comments 备注: </Row>
                        {
                            !loading && <TextArea
                                rows={4}
                                defaultValue={note.note}
                                onBlur={(e) => {
                                    const v = e.target.value || "";
                                    this.setState({ note: { ...note, note: v } });
                                }}

                            />
                        }

                    </Row>
                    <Row className="table-footer-btn">
                        <Alert
                            message={
                                <div>
                                    表格关联
                                    <IsLableAuth auth="read_1" {...this.props} path="/table/1">1.1</IsLableAuth> -
                                    <IsLableAuth auth="read_7_1" {...this.props} path="/table/7_1">7.1</IsLableAuth> -
                                    <IsLableAuth auth="read_7_7" {...this.props} path="/table/7_7">7.7</IsLableAuth>
                                </div>
                            }
                            type="info"
                            showIcon
                            style={{ display: "inline-block", marginRight: 10 }}
                        />
                        <Button
                            type="primary"
                            style={{ marginRight: 10 }}
                            onClick={() => {
                                this.setState({ print: true }, () => {
                                    this.downloadExcel();
                                });
                            }}
                            loading={print}
                        >导出Excel</Button>
                        <Auth loading={loading} auth="edit_7_8">

                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入pdf</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Auth>
                    </Row>
                </div>
                <Chart />
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/hr/table/9.0/index.js